import React from 'react';
import U from './ticket_stub_utils';
import TypeLevelTicket from './templates/type_level_ticket';
import TypeLevelSectionRowSeatTicket from './templates/type_level_section_row_seat_ticket';
import LevelSectionRowSeatTicket from './templates/level_section_row_seat_ticket';
import TypeSectionRowSeatTicket from './templates/type_section_row_seat_ticket';
import TypeLevelSectionRowTicket from './templates/type_level_section_row_ticket';
import TypeLevelSectionTicket from './templates/type_level_section_ticket';
import TypeSectionRowTicket from './templates/type_section_row_ticket';
import SectionRowSeatTicket from './templates/section_row_seat_ticket';
import LevelRowSeatTicket from './templates/level_row_seat_ticket';
import TypeSectionTicket from './templates/type_section_ticket';
import LevelSectionTicket from './templates/level_section_ticket';
import TypeLevelRowSeatTicket from './templates/type_level_row_seat_ticket';
import LevelTicket from './templates/level_ticket';
import SectionTicket from './templates/section_ticket';
import Upsell from './templates/upsell';
import MyAccountTemplate from './templates/my_account_template';
import BasketTemplate from './templates/basket_template';
import PriceTypeSelectorTemplate from './templates/pricetype_selector_template';

function addMyAccountTemplate (Component, ticket, onClick) {
  return <MyAccountTemplate onClick={onClick} ticket={ticket}>
    <Component ticket={ticket} />
  </MyAccountTemplate>;
}

function addBasketTemplate (Component, ticket, onClick) {
  return <BasketTemplate onClick={onClick} ticket={ticket}>
    <Component ticket={ticket} />
  </BasketTemplate>;
}

function addPriceTypeSelectorTemplate (Component, ticket) {
  return <PriceTypeSelectorTemplate>
    <Component ticket={ticket} />
  </PriceTypeSelectorTemplate>;
}

function makeComponentFunc (templateFunc) {
  return (ticket, onClick) => {
    if (U.getTicketListItemType(ticket) === U.UPSELL) {
      return <Upsell upsell={ticket} onClick={onClick} />;
    }

    if (U.getTicketListItemType(ticket) === U.TYPE_LEVEL_SECTION_ROW_SEAT_TICKET) {
      return templateFunc(TypeLevelSectionRowSeatTicket, ticket, onClick);
    }

    if (U.getTicketListItemType(ticket) === U.LEVEL_SECTION_ROW_SEAT_TICKET) {
      return templateFunc(LevelSectionRowSeatTicket, ticket, onClick);
    }

    if (U.getTicketListItemType(ticket) === U.TYPE_LEVEL_ROW_SEAT_TICKET) {
      return templateFunc(TypeLevelRowSeatTicket, ticket, onClick);
    }

    if (U.getTicketListItemType(ticket) === U.TYPE_LEVEL_SECTION_ROW_TICKET) {
      return templateFunc(TypeLevelSectionRowTicket, ticket, onClick);
    }

    if (U.getTicketListItemType(ticket) === U.TYPE_SECTION_ROW_SEAT_TICKET) {
      return templateFunc(TypeSectionRowSeatTicket, ticket, onClick);
    }

    if (U.getTicketListItemType(ticket) === U.TYPE_LEVEL_SECTION_TICKET) {
      return templateFunc(TypeLevelSectionTicket, ticket, onClick);
    }

    if (U.getTicketListItemType(ticket) === U.SECTION_ROW_SEAT_TICKET) {
      return templateFunc(SectionRowSeatTicket, ticket, onClick);
    }

    if (U.getTicketListItemType(ticket) === U.LEVEL_ROW_SEAT_TICKET) {
      return templateFunc(LevelRowSeatTicket, ticket, onClick);
    }

    if (U.getTicketListItemType(ticket) === U.TYPE_SECTION_ROW_TICKET) {
      return templateFunc(TypeSectionRowTicket, ticket, onClick);
    }

    if (U.getTicketListItemType(ticket) === U.TYPE_SECTION_TICKET) {
      return templateFunc(TypeSectionTicket, ticket, onClick);
    }

    if (U.getTicketListItemType(ticket) === U.LEVEL_SECTION_TICKET) {
      return templateFunc(LevelSectionTicket, ticket, onClick);
    }

    if (U.getTicketListItemType(ticket) === U.TYPE_LEVEL_TICKET) {
      return templateFunc(TypeLevelTicket, ticket, onClick);
    }

    if (U.getTicketListItemType(ticket) === U.LEVEL_TICKET) {
      return templateFunc(LevelTicket, ticket, onClick);
    }

    if (U.getTicketListItemType(ticket) === U.SECTION_TICKET) {
      return templateFunc(SectionTicket, ticket, onClick);
    }

    return false;
  };
}

const makeMyAccountTicketStub = makeComponentFunc(addMyAccountTemplate);
const makeBasketTicketStub = makeComponentFunc(addBasketTemplate);
const makePriceTypeSelectorTicketStub = makeComponentFunc(addPriceTypeSelectorTemplate);

export default  {
  makePriceTypeSelectorTicketStub: makePriceTypeSelectorTicketStub,
  makeBasketTicketStub: makeBasketTicketStub,
  makeMyAccountTicketStub: makeMyAccountTicketStub
};



// WEBPACK FOOTER //
// ./frontend/react/components/common/ticket_stub/ticket_stub_factory.js